<template>
  <i v-if="isVisible"
     class="pi pi-exclamation-triangle warning-color p-ml-1 changed-after-export-icon"
     :style="iconStyle"
     v-tooltip.top="$t('changedAfterExportTooltip')"/>
</template>

<script>
export default {
  name: 'ChangedAfterExportIcon',
  props: {
    show: {
      type: [Boolean, Number, String],
      default: false,
    },

    size: {
      type: String,
      default: '1.25rem',
    },

    top: {
      type: String,
      default: null,
    },
  },

  computed: {
    isVisible() {
      return Number(this.show) === 1 || this.show === true
    },

    iconStyle() {
      return {
        fontSize: this.size,
        position: this.top ? 'relative' : null,
        top: this.top,
      }
    },
  },
}
</script>

<style scoped>
.changed-after-export-icon {
  vertical-align: middle;
}
</style>